/**
 * Directive permettant d'ajouter la classe "required" (faisant apparaitre l'asterisque) si le formControl passé en entrée est effectivement obligatoire.
 */
import {Directive, HostBinding, Input} from '@angular/core';
import {FormControl} from '@angular/forms';

@Directive({
	standalone: true,
	selector: '[champObligatoire]'
})
export class ChampObligatoireDirective {

	@Input('champObligatoire')
	formControl: FormControl;

	@HostBinding('class.label-required')
	public get estObligatoire(): boolean {
		// hack pour verifier si le formControl possède le validator required : appeler la fonction de validation du control,
		// en lui passant une copie du formControl d'origine auquel la value a été enlevée (attribut readonly !!) afin que l'erreur required apparaisse
		const {value, ...formControlSansValue} = this.formControl;
		const fakeFormControl = Object.assign(new FormControl(), formControlSansValue);
		const validator = this.formControl.validator ? this.formControl.validator(fakeFormControl) : null;
		return validator && validator['required'];
	}
}
